<template>
  <div class="groupFields">
    <div class="groupField">
      <div class="groupFieldTitle">
        <span class="groupFieldTitle-text">Exception</span>
	      <v-btn
			      @click="onAddDispatcherItem" type="button"
			      depressed
			      class="mainBtn mainBtn-text"
	      >
		      <span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
		      <span class="btnText">Add exception</span>
	      </v-btn>
      </div>
      <template v-for="(item, idx) in exceptionList">
        <div class="groupField_wrap" :key="idx">
          <field
              :classError="valid.exceptionList.$each.$iter[idx]['type'].$error"
              margin="0 10px 0 0"
              width="170px"
              label="Trailer type"
              placeholder="Select trailer type"
              @updateAutocomplete="onExceptionAutocomplete($event, 'type')"
              :autocompleteValue="item.type"
              :items="getTrailerRate"
              :idx="idx"
              item-value="trailer_type_id"
              item-text="name"
              :is-clearable="false"
              is-autocomplete
              is-required
          ></field>
            <field
                margin="0 10px 0 0"
                width="190px"
                label="Truck"
                placeholder="Select Truck"
                @updateAutocomplete="onExceptionAutocomplete($event, 'truck_id')"
                :autocompleteValue="item.truck_id"
                :items="getTracks"
                :idx="idx"
                :is-clearable="false"
                is-autocomplete
            ></field>
          <field
              margin="0 10px 0 0"
              width="145px"
              label="Payment type"
              placeholder="Select payment type"
              :autocompleteValue="item.rate"
              :items="getPercentType"
              :is-clearable="false"
              is-autocomplete
              is-disabled
          ></field>
          <field
              :classError="valid.exceptionList.$each.$iter[idx]['amount'].$error"
              margin="0 10px 0 0"
              width="120px"
              type="number"
              label="Rate amount"
              placeholder="0"
              :idx="idx"
              @updateInput="onInput($event)"
              :setInputValue="item['amount']"
              :is-readonly="!item.type"
              is-required
          ></field>
          <button type="button" class="deleteItem" @click="onDeleteItem(idx, item.id)">
            <svg-sprite style="color: #19BC38" width="20" height="20" icon-id="deleteItem"></svg-sprite>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
	name: "DispatchException",
	props: {
		valid: Object
	},
	computed: {
		...mapGetters([ 'customersList' ]),
		getPercentType() {
			return this.customersList['percent_types'];
		},
		getTrailerRate() {
			return [ { trailer_type_id: 99, name: 'All trailers' }, ...this.customersList['trailer_rate'] ];
		},
		getTracks() {
			if (!this.customersList['trucks']) return [];
			return [ { id: 0, value: 'All trucks' }, ...this.customersList['trucks'] ];
		}
	},
	data: () => ({
		exceptionList: []
	}),
	methods: {
		...mapActions([ 'getDeleteException' ]),
		onAddDispatcherItem() {
			const values = {
				type: null,
				rate: { id: 1, value: '%' },
				truck_id: null,
				id: null,
				amount: 0
			};
   
			console.info('%c 111', 'color: #FFB02E', this.exceptionList);
			console.info('%c 222', 'color: #FFB02E', values);

			this.exceptionList.push(values);
			this.getData();
		},
		onExceptionAutocomplete({ value, idx }, key) {
			this.exceptionList[idx][key] = value;
			this.getData();
		},
		onInput({ value, idx }) {
			this.exceptionList[idx]['amount'] = +value;
			this.getData();
		},
		onDeleteItem(idx, id) {
			if (id) this.getDeleteException({ id });
			this.exceptionList.splice(idx, 1);
			this.getData();
		},
		getData() {
			this.$emit('updateExceptionData', this.exceptionList);
		}
	},
	mounted() {
		const { exceptionList = [] } = this.customersList;
  
		this.exceptionList = exceptionList.map(item => {
			const { type, truck_id } = item;
			item.rate = { id: 1, value: '%' };
			item.type = this.getTrailerRate.find(item => item.trailer_type_id === +type);
			item.truck_id = this.getTracks.find(item => item.id === truck_id);

			return item;
		});
	}
};
</script>

<style scoped lang="scss">
@import "DispatchException";
</style>
